/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ServiceSubscriptionDto { 
    shortCode?: string;
    keyword?: string;
    creatorId?: string;
    errorMessage?: string;
    susbcriberPhoneNumber?: string;
    serviceProviderName?: string;
    autoRenew: boolean;
}
